"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = require("react");
const FormElement = styled_components_1.default.form `
  margin: ${(props) => props.theme.spacings.m} 0;
  label {
    letter-spacing: -0.01rem;
    display: block;
    margin-bottom: ${(props) => props.theme.spacings.xs};
  }
  a {
    cursor: pointer;
    display: block;
    text-decoration: underline;
    font-size: 0.875rem;
    text-align: center;
    color: ${(props) => props.theme.colors.greyBase};
    margin-top: ${(props) => props.theme.spacings.xl};
  }

  input[data-err] {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
const horizontal = (0, styled_components_1.default)(FormElement) `
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  * {
    align-self: baseline;
    flex: 1;
    &:not(:last-child) {
      margin-right: ${(props) => props.theme.spacings.m};
    }
  }

  button {
    display: inline-flex;
    width: auto;
    flex: 0;
  }
`;
const vertical = (0, styled_components_1.default)(FormElement) `
  input,
  button {
    margin-bottom: ${(props) => props.theme.spacings.m};
  }

  input[data-err] + p {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }
`;
const Form = (0, react_1.forwardRef)((props, ref) => {
    const variant = props.variant ? props.variant : "vertical";
    return (0, react_1.createElement)({ horizontal, vertical }[variant], {
        ...props,
        ref: ref
    });
});
exports.Form = Form;
//# sourceMappingURL=form.js.map